import { Injectable } from '@angular/core';

import { Icon } from './icon.interface';

@Injectable({ providedIn: 'root' })
export class IconsRegistryService {
  private readonly registry = new Map<string, string>();

  registerIcons(icons: Icon[]): void {
    icons.forEach((icon) => this.registry.set(icon.name, icon.data));
  }

  getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      console.warn(`Icon ${iconName} not found in the registry.`);
    }
    return this.registry.get(iconName);
  }
}
